import { SELECT_TOURNAMENT, SET_TOURNAMENTS } from "../constants/tournaments"

export const setTournaments = tournaments => dispatch =>{
    dispatch({
        type: SET_TOURNAMENTS,
        payload:tournaments
    })
}

export const selectTournament = tournament => dispatch =>{
    dispatch({
        type: SELECT_TOURNAMENT,
        payload: tournament
    })
}